import "./holiday-cabin-class-tabs.scss";

import { cabinClassEnum } from "../../../common/enums/cabinClassEnum";
import { useEffect } from "react";

const HolidayCabinClassTabs = ({
  cabinClassOptions,
  handleOnClickTab,
  cabinClassContentfulData,
  setCurrentCabinClass,
  isPremiumEconomyEnabled,
  selectedCabinClassCode,
}) => {
  useEffect(() => {
    if (selectedCabinClassCode?.length > 0) {
      setCurrentCabinClass(selectedCabinClassCode[0]);
    }
  }, [selectedCabinClassCode]);

  const getTabClassNames = (
    optionData,
    uniqueClassName,
    selectedCabinClassCode,
    cabinClassName
  ) => {
    let classes = [uniqueClassName, "cabin-class-tab"];

    if (!optionData.enabled) {
      classes.push("tab-disabled");
    }

    const selectedCabin = selectedCabinClassCode?.[0]?.trim();
    if (cabinClassName === selectedCabin) {
      classes.push("tab-selected");
    }

    return classes.join(" ");
  };

  const CabinClassTab = ({
    cabinClassName,
    cabinClassOptionData,
    uniqueClassName,
  }) => {
    return (
      cabinClassOptionData && (
        <div
          className={getTabClassNames(
            cabinClassOptionData,
            uniqueClassName,
            selectedCabinClassCode,
            cabinClassName
          )}
          onClick={() => {
            if (cabinClassOptionData.enabled) handleOnClickTab(cabinClassName);
          }}
        >
          {cabinClassOptionData.displayName}
          {!cabinClassOptionData.enabled && (
            <span className="tab-disabled__label">
              {cabinClassContentfulData?.notAvailable}
            </span>
          )}
        </div>
      )
    );
  };

  return (
    cabinClassOptions && (
      <div className="cabin-class-tabs">
        <CabinClassTab
          cabinClassName={cabinClassEnum.apiKeys.Economy}
          cabinClassOptionData={cabinClassOptions.Economy}
          uniqueClassName="economy-class"
        />
        {isPremiumEconomyEnabled && (
          <CabinClassTab
            cabinClassName={cabinClassEnum.apiKeys.PremiumEconomy}
            cabinClassOptionData={cabinClassOptions.PremiumEconomy}
            uniqueClassName="premium-economy-class"
          />
        )}
        <CabinClassTab
          cabinClassName={cabinClassEnum.apiKeys.Business}
          cabinClassOptionData={cabinClassOptions.Business}
          uniqueClassName="business-class"
        />
      </div>
    )
  );
};

export default HolidayCabinClassTabs;
